import React, { Component } from 'react';

import PartialBlog from './PartialBlog';
import { Button } from './ui/Button';

class BlockRecommended extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { next, previous } = this.props;
    return (
      <>
        <div className="container pb-20 md:pb-20 lg:pb-32">
          <div className="grid grid-cols-4 md:grid-cols-12">
            <div className="col-span-4 pb-24 pt-24 md:col-span-12 lg:pb-40 lg:pt-40">
              <hr />
            </div>
            <div className="col-span-4 md:col-span-4 md:pb-20">
              <p className="h2 color--primary">More insights &amp; stories</p>
            </div>
            <div className="col-span-4 pb-20 md:col-span-5 md:col-start-6">
              <p className="mb-10">
                There’s more where that came from.
                <br />
                Get in the know and check out our additional insights
              </p>
              <Button
                variant="secondary"
                href="/blog"
                size="lg"
                className="md-down:w-full md-down:[&_*]:w-full">
                View all posts
              </Button>
            </div>
          </div>
          <div className="grid grid-cols-4 gap-10 md:grid-cols-12">
            {next && <PartialBlog post={next} type="blog" />}
            {previous && <PartialBlog post={previous} type="blog" />}
          </div>
        </div>
      </>
    );
  }
}
export default BlockRecommended;
